import React from 'react';
import './LegalPage.css';

function PrivacyPolicyPage() {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1 className="legal-page-title">PRIVACY POLICY</h1>

        <div className="legal-section">
          <h2>I. PRIVACY AND DATA PROTECTION POLICY</h2>
          <p>
            In compliance with current legislation, TABIA GROUP (hereinafter, also the Website) undertakes
            to adopt the necessary technical and organisational measures, at the appropriate level of
            security for the risk of the data collected.
          </p>

          <h3>Laws incorporated in this privacy policy</h3>
          <p>
            This privacy policy is adapted to current Spanish and European regulations on the protection
            of personal data on the internet. Specifically, it complies with the following regulations:
          </p>
          <ul>
            <li>
              Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016,
              on the protection of natural persons with regard to the processing of personal data and on
              the free movement of such data (GDPR).
            </li>
            <li>
              Organic Law 3/2018 of 5 December, on the Protection of Personal Data and guarantee of
              digital rights (LOPDGDD).
            </li>
            <li>
              Royal Decree 1720/2007 of 21 December, approving the Regulation implementing Organic Law
              15/1999 of 13 December, on the Protection of Personal Data (RDLOPD).
            </li>
            <li>
              Law 34/2002 of 11 July, on Information Society Services and Electronic Commerce (LSSI-CE).
            </li>
          </ul>

          <h3>Identity of the data controller</h3>
          <p>
            The data controller for the personal data collected by TABIA GROUP is: Tabia Group S.L, with
            Tax ID: B16626871, registered at: the Mercantile Registry of Palma de Mallorca with the
            following registration details: No. 313304. T 2821, F 38, S 8, H PM 87095, I/A 1, whose
            representative is: David Pons Camps (hereinafter, the Data Controller). Contact details are
            as follows:
          </p>
          <ul>
            <li>Address: Calle de la gerreria, 26. 1ºB, 07002, Palma de Mallorca</li>
            <li>Contact phone: 871533824</li>
            <li>Contact email: <a href="mailto:info@tabiagroup.com">info@tabiagroup.com</a></li>
          </ul>

          <h3>Registration of Personal Data</h3>
          <p>
            In compliance with the GDPR and LOPDGDD, we inform you that the personal data collected by
            TABIA GROUP through the forms on its pages will be incorporated and processed in our file in
            order to facilitate, expedite and fulfil the commitments established between TABIA GROUP and
            the User, or to maintain the relationship established in the forms completed by the User, or
            to attend to a request or enquiry from them. Furthermore, in accordance with the GDPR and
            LOPDGDD, unless the exception provided for in Article 30.5 of the GDPR applies, a record of
            processing activities is maintained that specifies, according to their purposes, the processing
            activities carried out and the other circumstances established in the GDPR.
          </p>

          <h3>Principles applicable to the processing of personal data</h3>
          <p>
            The processing of the User's personal data shall be subject to the following principles set
            out in Article 5 of the GDPR and Article 4 et seq. of Organic Law 3/2018 of 5 December, on
            the Protection of Personal Data and guarantee of digital rights:
          </p>
          <ul>
            <li><strong>Principle of lawfulness, fairness and transparency:</strong> the User's consent will always be required following completely transparent information about the purposes for which personal data are collected.</li>
            <li><strong>Principle of purpose limitation:</strong> personal data will be collected for specified, explicit and legitimate purposes.</li>
            <li><strong>Principle of data minimisation:</strong> only the personal data strictly necessary in relation to the purposes for which they are processed will be collected.</li>
            <li><strong>Principle of accuracy:</strong> personal data must be accurate and kept up to date at all times.</li>
            <li><strong>Principle of storage limitation:</strong> personal data will only be kept in a form that permits identification of the User for as long as necessary for the purposes of their processing.</li>
            <li><strong>Principle of integrity and confidentiality:</strong> personal data will be processed in a manner that ensures their security and confidentiality.</li>
            <li><strong>Principle of proactive responsibility:</strong> the Data Controller shall be responsible for ensuring that the above principles are complied with.</li>
          </ul>

          <h3>Categories of personal data</h3>
          <p>
            The categories of data processed by TABIA GROUP are solely identification data. Under no
            circumstances are special categories of personal data processed within the meaning of
            Article 9 of the GDPR.
          </p>

          <h3>Legal basis for processing personal data</h3>
          <p>
            The legal basis for processing personal data is consent. TABIA GROUP undertakes to obtain
            the User's express and verifiable consent for the processing of their personal data for one
            or more specific purposes.
          </p>
          <p>
            The User shall have the right to withdraw their consent at any time. Withdrawing consent
            shall be as easy as giving it. As a general rule, withdrawal of consent shall not affect
            use of the Website.
          </p>
          <p>
            On occasions where the User must or may provide their data through forms to make enquiries,
            request information or for reasons related to the content of the Website, they will be
            informed if completing any of them is mandatory because they are essential for the correct
            completion of the operation carried out.
          </p>

          <h3>Purposes of processing personal data</h3>
          <p>
            Personal data are collected and managed by TABIA GROUP in order to facilitate, expedite and
            fulfil the commitments established between the Website and the User, or to maintain the
            relationship established in the forms completed by the User, or to attend to a request or
            enquiry from them.
          </p>
          <p>
            Similarly, the data may be used for commercial personalisation, operational and statistical
            purposes, and activities inherent to the corporate purpose of TABIA GROUP, as well as for
            data extraction, storage and marketing studies to adapt the Content offered to the User, and
            to improve the quality, operation and navigation of the Website.
          </p>
          <p>
            At the time personal data are obtained, the User will be informed of the specific purpose or
            purposes of the processing to which the personal data will be used.
          </p>

          <h3>Personal data retention periods</h3>
          <p>
            Personal data will only be retained for the minimum time necessary for the purposes of their
            processing and, in any event, only for the following period: 2 years, or until the User
            requests their deletion.
          </p>
          <p>
            At the time personal data are obtained, the User will be informed of the period for which
            the personal data will be retained or, where that is not possible, the criteria used to
            determine that period.
          </p>

          <h3>Recipients of personal data</h3>
          <p>The User's personal data will not be shared with third parties.</p>
          <p>
            In any event, at the time personal data are obtained, the User will be informed of the
            recipients or categories of recipients of the personal data.
          </p>

          <h3>Personal data of minors</h3>
          <p>
            In compliance with Articles 8 of the GDPR and 7 of Organic Law 3/2018 of 5 December, on
            the Protection of Personal Data and guarantee of digital rights, only persons aged 14 or
            over may lawfully give their consent for the processing of their personal data by TABIA
            GROUP. In the case of a person under 14, the consent of parents or guardians will be
            required for processing, and this will only be considered lawful to the extent that they
            have authorised it.
          </p>

          <h3>Secrecy and security of personal data</h3>
          <p>
            TABIA GROUP undertakes to adopt the necessary technical and organisational measures, at the
            appropriate level of security for the risk of the data collected, in order to guarantee the
            security of personal data and prevent the accidental or unlawful destruction, loss or
            alteration of personal data transmitted, stored or otherwise processed, or the unauthorised
            communication of or access to such data.
          </p>
          <p>
            The Website has an SSL (Secure Socket Layer) certificate, which ensures that personal data
            are transmitted securely and confidentially, as the transmission of data between the server
            and the User, and in feedback, is fully encrypted.
          </p>
          <p>
            However, because TABIA GROUP cannot guarantee the impenetrability of the internet or the
            complete absence of hackers or others who may fraudulently access personal data, the Data
            Controller undertakes to notify the User without undue delay when a personal data breach
            occurs that is likely to result in a high risk to the rights and freedoms of natural persons.
            In accordance with Article 4 of the GDPR, a personal data breach means a security breach
            leading to the accidental or unlawful destruction, loss, alteration, unauthorised disclosure
            of, or access to, personal data transmitted, stored or otherwise processed.
          </p>
          <p>
            Personal data will be treated as confidential by the Data Controller, who undertakes to
            inform and ensure through a legal or contractual obligation that such confidentiality is
            respected by their employees, associates, and any person to whom they make the information
            accessible.
          </p>

          <h3>Rights arising from the processing of personal data</h3>
          <p>
            The User has rights over TABIA GROUP and may therefore exercise the following rights
            recognised under the GDPR and Organic Law 3/2018 of 5 December, on the Protection of
            Personal Data and guarantee of digital rights, against the Data Controller:
          </p>
          <ul>
            <li><strong>Right of access:</strong> the User's right to obtain confirmation as to whether or not TABIA GROUP is processing their personal data and, if so, to obtain information about their specific personal data and the processing carried out or being carried out by TABIA GROUP, as well as, among other things, information available about the origin of such data and the recipients of any communications made or planned.</li>
            <li><strong>Right of rectification:</strong> the User's right to have their personal data modified if it proves to be inaccurate or, taking into account the purposes of the processing, incomplete.</li>
            <li><strong>Right of erasure ("the right to be forgotten"):</strong> the User's right, unless current legislation provides otherwise, to obtain the erasure of their personal data when it is no longer necessary for the purposes for which it was collected or processed; the User has withdrawn consent for processing and no other legal basis exists; the User objects to processing and there is no other legitimate reason to continue; the personal data has been processed unlawfully; the personal data must be deleted to comply with a legal obligation; or the personal data was obtained in connection with a direct offer of information society services to a child under 14.</li>
            <li><strong>Right to restriction of processing:</strong> the User's right to restrict the processing of their personal data. The User has the right to obtain restriction of processing where they contest the accuracy of their personal data; processing is unlawful; the Data Controller no longer needs the personal data but the User needs it to make claims; and where the User has objected to processing.</li>
            <li><strong>Right to data portability:</strong> where processing is carried out by automated means, the User has the right to receive their personal data from the Data Controller in a structured, commonly used and machine-readable format, and to transmit it to another controller. Where technically feasible, the Data Controller will transmit the data directly to the other controller.</li>
            <li><strong>Right to object:</strong> the User's right to prevent the processing of their personal data or to have TABIA GROUP cease such processing.</li>
            <li><strong>Right not to be subject to a decision based solely on automated processing, including profiling:</strong> the User's right not to be subject to an individual decision based solely on the automated processing of their personal data, including profiling, unless current legislation provides otherwise.</li>
          </ul>
          <p>
            The User may exercise their rights by sending a written communication to the Data Controller
            with the reference "GDPR-www.tabiagroup.com", specifying:
          </p>
          <ul>
            <li>The User's full name and a copy of their ID document.</li>
            <li>The request with the specific reasons for the request or the information to which access is sought.</li>
            <li>Address for notification purposes.</li>
            <li>Date and signature of the applicant.</li>
            <li>Any document supporting the request.</li>
          </ul>
          <p>This request and any attached documents may be sent to the following address and/or email:</p>
          <ul>
            <li>Postal address: Calle de la gerreria, 26. 1ºB, 07002, Palma de Mallorca</li>
            <li>Email: <a href="mailto:info@tabiagroup.com">info@tabiagroup.com</a></li>
          </ul>

          <h3>Links to third-party websites</h3>
          <p>
            The Website may include hyperlinks or links that allow access to web pages of third parties
            other than TABIA GROUP, which are therefore not operated by TABIA GROUP. The owners of such
            websites will have their own data protection policies, and they themselves will be responsible,
            in each case, for their own files and their own privacy practices.
          </p>

          <h3>Complaints to the supervisory authority</h3>
          <p>
            If the User considers that there is a problem or infringement of current regulations in the
            way their personal data is being processed, they shall have the right to effective judicial
            protection and to lodge a complaint with a supervisory authority, in particular in the Member
            State of their habitual residence, place of work or place of the alleged infringement. In
            Spain, the supervisory authority is the Spanish Data Protection Agency (<a href="https://www.aepd.es/" target="_blank" rel="noopener noreferrer">https://www.aepd.es/</a>).
          </p>
        </div>

        <div className="legal-section">
          <h2>II. ACCEPTANCE AND CHANGES TO THIS PRIVACY POLICY</h2>
          <p>
            The User must have read and agreed to the conditions on the protection of personal data
            contained in this Privacy Policy, and must accept the processing of their personal data in
            order for the Data Controller to proceed in the manner, within the time limits and for the
            purposes indicated. Use of the Website will imply acceptance of its Privacy Policy.
          </p>
          <p>
            TABIA GROUP reserves the right to modify its Privacy Policy at its own discretion, or
            motivated by a legislative, jurisprudential or doctrinal change from the Spanish Data
            Protection Agency. Changes or updates to this Privacy Policy will not be explicitly notified
            to the User. The User is advised to consult this page periodically to keep up to date with
            the latest changes or updates.
          </p>
          <p>
            This Privacy Policy was updated to comply with Regulation (EU) 2016/679 of the European
            Parliament and of the Council of 27 April 2016, on the protection of natural persons with
            regard to the processing of personal data and on the free movement of such data (GDPR), and
            Organic Law 3/2018 of 5 December, on the Protection of Personal Data and guarantee of
            digital rights.
          </p>
        </div>

      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
